import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { getTextAreaLength } from '../../../utils/form.utils';

@Component({
  selector: 'app-note-dialog',
  templateUrl: './note-dialog.component.html',
  styleUrl: './note-dialog.component.scss',
  standalone: false,
})
export class NoteDialogComponent {
  public title: string = '';
  public noteForm: FormGroup = new FormGroup({
    note: new FormControl('', Validators.required),
  });

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    if (this.config.data?.note) {
      this.noteForm.patchValue({ note: config.data.note });
    }
    this.title = this.config.data.title;
  }

  public getTextAreaLength = getTextAreaLength;

  public saveNote() {
    if (!this.noteForm.valid) {
      console.error('Form is invalid');
      return;
    }
    this.dialogRef.close(this.noteForm.value.note);
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
